module.exports = __webpack_public_path__ + "img/HERO-head-08-Sorkrorob.05c35f45.png";